<template>
    <div class="news-box">
        <!-- 新闻列表 -->
        <div class="news">
            <p class="place">您所在的位置：<span class="place-text">数说家庭</span></p>
            <!-- <p>暂无新闻</p> -->
            <div class="news-list">
                <div class="news-item" v-for="(item, index) in newsList" :key="index" @click="toDetail(item)">
                    <div class="news-date">
                        <div class="date">{{ item.id }}</div>
                    </div>
                    <div class="news-text">{{ item.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'news',
        data() {
            return {
                newsList: [
                    {
                        id: 1,
                        name: '集团数据大屏',
                        url: 'https://datav.aliyuncs.com/share/67806f1268ebd58ae3877a41f8d82962'
                    },
                    {
                        id: 2,
                        name: '幸福路数据大屏(一)',
                        url: 'https://datav.aliyuncs.com/share/a7eb711c69c4621368bfc2f7c10d707d'
                    },
                    {
                        id: 3,
                        name: '幸福路数据大屏(二)',
                        url: 'https://datav.aliyuncs.com/share/053fef99c3a58f183a66767807e51ec1'
                    },
                    {
                        id: 4,
                        name: '幸福路数据大屏(三)',
                        url: 'https://datav.aliyuncs.com/share/95cab9eccd07de1e3b24331154120bbc'
                    },
                    {
                        id: 5,
                        name: '幸福路家庭教育公众号数据大屏',
                        url: 'https://datav.aliyuncs.com/share/c76bb8b8b2b1551e636661a0c679ed6f'
                    },
                    {
                        id: 6,
                        name: '泰山妈妈说公众号数据大屏',
                        url: 'https://datav.aliyuncs.com/share/f6f89463eafb0d7d3105611c28f3de6d'
                    },
                    {
                        id: 7,
                        name: '版权平台、短视频数据大屏',
                        url: 'https://datav.aliyuncs.com/share/79d319d593a9c96e7a6e3b7ae5bd8c12'
                    }
                    

                ]
            }
        },
        methods: {
            toDetail(e) {
                window.open(e.url, "_blank")  
            }
        }
    }
</script>

<style lang="less" scoped>
    // @import '~@/assets/css/quill.core.css';
    // @import '~@/assets/css/quill.bubble.css';
    // @import '~@/assets/css/quill.snow.css';
    .news-box {
        background-color: #FAF9F9;
        width: 100%;
        // height: 100vh;
        .news {
            width: 1160px;
            margin: 0 auto;
            padding: 30px 0px;
            box-sizing: border-box;
            .place {
                font-size: 15px;
                font-weight: 500;
                color: #333333;
                line-height: 21px;
                cursor: pointer;
                .place-text {
                    color: #0091FF;  
                }
            }
            .news-list {
                .news-item {
                    width: 100%;
                    height: 100px;
                    padding: 30px 0;
                    box-sizing: border-box;
                    border-bottom: 1px dashed #979797;
                    display: flex;
                    cursor: pointer;
                    .news-date {
                        width: 80px;
                        height: 80px;
                        background: #FFFFFF;
                        border-radius: 4px;
                        padding: 8px 5px;
                        box-sizing: border-box;
                        text-align: center;
                        font-size: 23px;
                        font-weight: 500;
                        color: #333333;
                        .date {
                            border-bottom: 1px solid #ECEBEB;
                        }
                    }
                    .news-text {
                        width: 1065px;
                        margin-left: 15px;
                        line-height: 42px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        font-size: 24px;
                    }
                }
            }

        }
        .page-box {
            width: 100%;
            text-align: center;
            margin-top: 80px;
            /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #0091FF;
                color: #FFF;
            }
            /deep/.el-pager li {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 0;
                line-height: 40px;
                text-align: center;               
                font-size: 16px;
                border: 1px solid #D8D8D8;
                margin: 0;
            }
            /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .btn-next{
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 0;
                line-height: 40px;
                text-align: center;               
                font-size: 16px;
                border: 1px solid #D8D8D8;
                margin: 0;
            }
            /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
                color: #0091FF;
            }
        }
        .news-title {
            font-size: 30px;
            font-weight: 600;
            color: #333333;
            line-height: 42px;
            text-align: center;
            margin-top: 30px;
        }
        .news-info {
            font-size: 16px;
            font-weight: 400;
            color: #656464;
            line-height: 28px;
            text-align: center;
            margin-top: 20px;
            .news-info-item {
                margin-right: 10px;
            }
        }
        .article {
            width: 100%;
            margin-top: 20px;
        }
        // .ql-align-center {
        //     text-align: center !important;
        // }

        // .ql-editor .ql-font-serif {
        //     font-family: Georgia,Times New Roman,serif;
        //     line-height: 42px !important;
        // }
    }
</style>